import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { environmentLoader } from './environments/environment-loader';

environmentLoader.then(env => {
    if (env.production) {
        enableProdMode();
    }

    // copy env settings to environment
    for (const key in env) {
        if (Object.prototype.hasOwnProperty.call(env, key)) {
            environment[key] = env[key];
        }
      }

    platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
        .catch(err => console.error(err));
});
